export default "__VITE_ASSET__DEpyAvke__"